// removed by extract-text-webpack-plugin
module.exports = {"goalsCardContainer":"_36BHmbzHfMVTDSDjRt14_v","titleContainer":"_2kxw8o4X2lhi4Jhg0qiyzX","topBar":"_3Ekga040al--tACI1ooKs","marketContainer":"_3EFKQvI1PxHigqd0S1cwxs","marketTitle":"X9SaFzws7gKOWJO1Kwswy","container":"_1gCXgMbqh2p804ZRRqSErf","innerContainer":"_12pjSscklCVKxKCeMc1S3z","buttonStyle":"_3XvToWUD2qeNYfVCL_5uG_","toggle":"_35XwmEz5QT0aHjVWjj8f-J","slider":"_342mWQzyih7e_PVPFzkVkz","checked":"_1VTlccgIau7sNEU3rSBzdE","firstToggleOption":"xHyuG3wDFENWo2tV19Mry","secondToggleOption":"_1rp9LQ8uYhXooq47zUOZVk"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/football/css/goalsCard.css
// module id = 1004
// module chunks = 0